// extracted by mini-css-extract-plugin
export default {"crumbs":"breadcrumb_crumbs__NdQrI"};